import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { UserStatusCongratulationsBenefitsCardsListStyled } from './styled/UserStatusCongratulationsBenefitsStyled';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getUserStatusParamsSelector } from '../../../../app/userSelectors';
import UserStatusCongratulationsBenefitsRespawn from './UserStatusCongratulationsBenefitsRespawn';
import UserStatusCongratulationsBenefitsCashback from './UserStatusCongratulationsBenefitsCashback';
import UserStatusCongratulationsBenefitsPromocodeInfo from './UserStatusCongratulationsBenefitsPromocodeInfo';
import UserStatusCongratulationsBenefitsWithdrawalLimits from './UserStatusCongratulationsBenefitsWithdrawalLimits';
import UserStatusCongratulationsBenefitsPersonalManager from './UserStatusCongratulationsBenefitsPersonalManager';
import { getIsLocationPlatformDesktopSelector } from '../../../Location/locationSelectors';
import useIsShowUserStatusWithdrawalLimits from '../../hooks/useIsShowUserStatusWithdrawalLimits';

interface IUserStatusCongratulationsBenefitsProps {
    className?: string,
}

function UserStatusCongratulationsBenefits(props: IUserStatusCongratulationsBenefitsProps) {
    const { className } = props;
    const userStatusParams = useSelector(getUserStatusParamsSelector);
    const isPlatformDesktop = useSelector(getIsLocationPlatformDesktopSelector);
    const { getLangPath } = useLangContext();

    const isShowWithdrawalLimits = useIsShowUserStatusWithdrawalLimits(userStatusParams);

    if (!userStatusParams) {
        return null;
    }

    return <div className={classNames(className, 'w-100 flex-1')}>
        <span className={'text-secondary'}>{getLangPath('user_statuses.gained_benefits')}</span>
        <UserStatusCongratulationsBenefitsCardsListStyled
            className={classNames({
                desktop: isPlatformDesktop,
                'hidden-scrollbar': true,
                'custom-scrollbar': true,
            })}
        >
            {userStatusParams?.gift_respawn && <UserStatusCongratulationsBenefitsRespawn/>}
            {userStatusParams?.cashback && <UserStatusCongratulationsBenefitsCashback/>}
            {userStatusParams?.giftPromocodeInfo && <UserStatusCongratulationsBenefitsPromocodeInfo/>}
            {isShowWithdrawalLimits && <UserStatusCongratulationsBenefitsWithdrawalLimits/>}
            {userStatusParams?.gift_manager && <UserStatusCongratulationsBenefitsPersonalManager/>}
        </UserStatusCongratulationsBenefitsCardsListStyled>
    </div>;
}

export default UserStatusCongratulationsBenefits;
